import { render, staticRenderFns } from "./goodsList.vue?vue&type=template&id=67a817e9&scoped=true&"
import script from "./goodsList.vue?vue&type=script&lang=js&"
export * from "./goodsList.vue?vue&type=script&lang=js&"
import style0 from "./goodsList.vue?vue&type=style&index=0&id=67a817e9&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67a817e9",
  null
  
)

export default component.exports